import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

const APOLLO_STARGATE_CONTEXT_ROOT = '/gateway/api/jsd-apollo-stargate/sharded/workspace';

export const deleteTopic = (
	projectId: number,
	topicId: string,
	activationId: string,
): Promise<void> => {
	return performDeleteRequest(
		`${APOLLO_STARGATE_CONTEXT_ROOT}/${activationId}/api/project/${projectId}/kb-topic/${topicId}`,
	);
};
